import { render, staticRenderFns } from "./pushlist.vue?vue&type=template&id=f4946286&scoped=true"
import script from "./pushlist.vue?vue&type=script&lang=js"
export * from "./pushlist.vue?vue&type=script&lang=js"
import style0 from "./pushlist.vue?vue&type=style&index=0&id=f4946286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4946286",
  null
  
)

export default component.exports